import { api_get } from '../../util'

const state = {
  list: []
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
  setList (state, list) {
    state.list = list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/brand.js